// extracted by mini-css-extract-plugin
module.exports = {"spinner_container":"_3_0Dp_kvZjCjMiGgVuVuuW","spinner":"_2oCafACbGMnzixuKdCs3-D"};